// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import ConfirmationDialog from 'presentations/views/components/molecules/ConfirmationDialog';

type Props = {
  isOpen: boolean;
  eventCount: number;
  onClickSubmit: () => void;
  onClickCancel: () => void;
};

export default function ConfirmRequestApproveDialog(props: Props) {
  const t = translateInComponent(translations);

  return (
    <ConfirmationDialog
      isOpen={props.isOpen}
      title={t('title')}
      text={t(props.eventCount > 0 ? 'content double booked' : 'content', {
        count: props.eventCount,
      })}
      submitLabel={t('submit')}
      cancelLabel={t('cancel')}
      onSubmit={props.onClickSubmit}
      onCancel={props.onClickCancel}
    />
  );
}
